import { AppState } from 'modules/types'

export const selectIsModalOpen = (state: AppState) => state.overlay.isModalOpen
export const selectModal = (state: AppState) => state.overlay.modal
